// extracted by mini-css-extract-plugin
export default {"text":"styles_text__ZNr8t","line":"styles_line__ZJPyh"};